var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63 40l3.281-14.793L0 15.26l14.373-1.309L20 0l5.63 13.95L40 15.258l-10.908 9.946 3.281 14.793-12.372-7.852L7.63 40z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDQwIDQwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNy42Mjk1MSA0MEwxMC45MTEgMjUuMjA2N0wwIDE1LjI2MUwxNC4zNzI1IDEzLjk1MjRMMjAuMDAxMyAwTDI1LjYzMDIgMTMuOTQ5Nkw0MCAxNS4yNTgyTDI5LjA5MTYgMjUuMjA0TDMyLjM3MzEgMzkuOTk3MkwyMC4wMDEzIDMyLjE0NTNMNy42Mjk1MSA0MFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgStar as ReactComponent };